const SelectAsOfSmartDateTexts = {
	defaultDatePlaceholder: 'Select Date',
	defaultSDPlaceholder: 'Select Smart Date',
};
export default SelectAsOfSmartDateTexts;
